import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=7a12ed5a&scoped=true&"
import script from "./Signature.vue?vue&type=script&lang=js&"
export * from "./Signature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a12ed5a",
  null
  
)

export default component.exports